import { toast } from "react-toastify";
import { DropdownActions, DropdownItem } from "../../commons/DropdownActions";
import type { Article } from "../../../services/webServices/article/types";
import { patchArticle } from "../../../services/webServices/article/patch";

type Props = {
  article: Article;
  onActionSuccessed: () => void;
};

export default function ArticleAction({ article, onActionSuccessed }: Props) {

  const updateArticleStatus = async (status: boolean): Promise<boolean> => {
    if (article.is_published === status) {
      toast.info("وضعیت همین الان هم همین است");
      return false;
    }

    try {
      const success = await patchArticle({
        slugOrId: article.id,
        body: { is_published: status }
      });

      if (!success) return false;

      toast.success("تغییر وضعیت با موفقیت انجام شد");
      onActionSuccessed();
      return true;
    } catch {
      return false;
    }
  };

  const actions: DropdownItem[] = [
    {
      key: "published",
      tone: "success",
      label: "انتشار",
      action: () => updateArticleStatus(true),
    },
    {
      key: "draft",
      tone: "warning",
      label: "پیش نویس",
      action: () => updateArticleStatus(false),
    },
  ];

  return (
    <DropdownActions
      items={actions}
      initialKey={article.is_published ? "published" : "draft"}
    />
  );
};